import { defineComponent as _defineComponent } from 'vue'
import Job, { JobStatus } from '@/models/job'
import { inventoriesAreEqual } from '@/utils/inventories'
import { useStore } from 'vuex-composition-helpers'
import { computed, onMounted, ref } from 'vue'
import JobLocationsAndInventoryEdit from './JobLocationsAndInventoryEdit.vue'
import FormLayout from '../common/FormLayout.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import VsBottomSheet from '@/components/vision/VsBottomSheet.vue'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'JobLocationsAndInventoryEditSaveWrapper',
  props: {
    job: null,
    jobHubId: null
  },
  emits: ['updated', 'dismiss'],
  setup(__props: any, { emit }) {

const props = __props as {
  job: Job
  jobHubId: string
}



// Emits


// Store
const store = useStore()

// State
const saving = ref(false)
const isSnackbarVisible = ref(false)
const inventories = ref<any[]>([]) // Adjust type based on inventory structure
const destinationLocationId = ref<number | null>(null)
const isBottomSheetVisible = ref(false)

// Computed
const ticketsError = computed(() => store.state.tickets.error)

const hasChanges = computed(() => {
  return (
    destinationLocationId.value !== props.job.destinationLocationId ||
    !inventoriesAreEqual(inventories.value, props.job.inventory)
  )
})

// Functions
const updateInventories = (newInventories: any[]) => {
  inventories.value = newInventories
}

const updateDestination = (newDestination: number) => {
  destinationLocationId.value = newDestination
}

const save = async () => {
  const inventoryEditComponent = inventoryEditComponentRef.value

  if (!inventoryEditComponent?.validate(JobStatus.COMPLETED)) return

  const updatedJob = Object.assign({}, props.job, {
    // This is to solve that customData can't be copied properly
    customData: props.job.customData,
    destinationLocationId: destinationLocationId.value,
    inventory: inventories.value,
  })

  saving.value = true
  await store.dispatch('jobs/updateJob', updatedJob)
  saving.value = false

  if (ticketsError.value) {
    isSnackbarVisible.value = true
  } else {
    emit('updated')
    dismiss()
  }
}

const dismiss = () => {
  emit('dismiss')
}

// Refs
const inventoryEditComponentRef = ref<InstanceType<
  typeof JobLocationsAndInventoryEdit
> | null>(null)

// Lifecycle Hook
onMounted(() => {
  destinationLocationId.value = props.job.destinationLocationId
  inventories.value = props.job.inventory
})

return { __sfc: true,props, emit, store, saving, isSnackbarVisible, inventories, destinationLocationId, isBottomSheetVisible, ticketsError, hasChanges, updateInventories, updateDestination, save, dismiss, inventoryEditComponentRef, JobLocationsAndInventoryEdit, FormLayout, VsWrapper, VsButton, VsSnackbar, VsBottomSheet }
}

})